module.exports = __webpack_public_path__ + "static/media/me.25e9af3d.png";